import React, { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import CompareViewDialog from './CompareViewDialog'
import useCompareMode from './useCompareMode'

import AdaptiveButton from '../AdaptiveButton'

import { useZustand } from '../../hooks/useZustand'

const updateComparisonModeSelector = state => state.updateComparisonMode

const doNotSaveGraphSelector = state => state.doNotSaveGraph

const CompareViewPanel = ({
    selectedComparisonView,
    onComparisonViewChange,
    addContextParams,
    forceFullButton = false,
}) => {
    const [viewOpen, setViewOpen] = useState(false)

    const { compareModeTitle } = useCompareMode()

    const [urlParams] = useSearchParams()
    const originalGraphName = urlParams.getAll('addcontext')

    // Set default comparison view to Compare Mode if addContextParam is present
    useEffect(() => {
        if (originalGraphName && originalGraphName.length > 0) {
            const mode = `Compare Mode: ${compareModeTitle}`
            onComparisonViewChange(mode)
        }
    }, [])

    const updateComparisonMode = useZustand(updateComparisonModeSelector)
    const doNotSaveGraph = useZustand(doNotSaveGraphSelector)

    const [comparisonMode, setComparisonMode] = useState('')

    useEffect(() => {
        if (compareModeTitle) {
            setComparisonMode(compareModeTitle)
        }
    }, [compareModeTitle])

    useEffect(() => {
        updateComparisonMode(comparisonMode)
    }, [comparisonMode])

    const handleViewClick = () => {
        setViewOpen(true)
    }

    const handleCloseModal = () => {
        setViewOpen(false)
    }

    const handleComparisonViewChange = mode => {
        const currentContext = useZustand.getState().currentContext

        if (mode === 'Original') {
            let statements = []

            addContextParams.forEach(context => {
                statements = [
                    ...statements,
                    ...useZustand.getState().statements[context],
                ]
            })

            const allIds = statements.map(({ uid }) => uid.toString())
            filterPanel.applyCategoryFilter(addContextParams, null, null, null)
        } else if (mode === 'Current') {
            let statements = useZustand.getState().statements[currentContext]

            const allIds = statements.map(({ uid }) => uid.toString())
            filterPanel.applyCategoryFilter([currentContext], null, null, null)
        } else {
            if (mode === 'Compare Mode: Difference') {
                filterPanel.applyCategoryFilter(
                    addContextParams,
                    [currentContext],
                    'filter_statements'
                )
            } else if (mode === 'Compare Mode: Combination') {
                const contextsToShow = [...addContextParams, currentContext]
                filterPanel.applyCategoryFilter(contextsToShow, null, null)
            } else if (mode === 'Compare Mode: Intersection') {
                filterPanel.clearAllFilters()
            } else if (mode === 'Compare Mode: Embedding') {
                filterPanel.clearAllFilters()
            }
        }

        // TODONEW - put this into Zustand
        onComparisonViewChange(mode)
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    gap: 1,
                    overflowX: 'scroll',
                    borderRadius: '4px',
                }}
            >
                {!doNotSaveGraph && (
                    <AdaptiveButton
                        onClick={handleViewClick}
                        buttonLabel="Compare To"
                        tooltipTitle="Compare Graphs to find the Similarities and Differences"
                        iconName="CompareIcon"
                        forceFullButton={forceFullButton}
                    />
                )}
            </Box>
            {viewOpen && (
                <CompareViewDialog
                    open={viewOpen}
                    onClose={handleCloseModal}
                    selectedComparisonView={selectedComparisonView}
                    onComparisonViewChange={handleComparisonViewChange}
                />
            )}
        </>
    )
}

export default CompareViewPanel
